import { ERoutes } from "../../../constants/routes";
import { SourceUsageTableRow } from "../../../components/SourceTable/types";
import { getDomainType } from "../../../utils/domainType/getDomainType";
import { getFaviconUrl } from "../../../utils/favicon/getFaviconUrl";
import { OverviewDomainsAggRow } from "../types";

interface DomainAgg {
  domain_id: number;
  domain: string;
  links_count: number;
  citations_count: number;
  responses_cited_count: number;
}

/** Aggregate raw API rows by domain (sum links/citations across dates). */
export function mapOverviewDomainsToTableRows(
  rows: OverviewDomainsAggRow[],
  indexOffset = 0
): SourceUsageTableRow[] {
  const byDomain = new Map<number, DomainAgg>();
  for (const r of rows) {
    const cur = byDomain.get(r.domain_id);
    if (cur) {
      cur.links_count += r.links_count;
      cur.citations_count += r.citations_count;
      cur.responses_cited_count += r.responses_cited_count ?? 0;
    } else {
      byDomain.set(r.domain_id, {
        domain_id: r.domain_id,
        domain: r.domain,
        links_count: r.links_count,
        citations_count: r.citations_count,
        responses_cited_count: r.responses_cited_count ?? 0,
      });
    }
  }
  const totalLinks = [...byDomain.values()].reduce((sum, r) => sum + r.links_count, 0);
  const sorted = [...byDomain.entries()].sort((a, b) => b[1].links_count - a[1].links_count);

  return sorted.map(([domainId, agg], index) => {
    const averageCitations =
      agg.responses_cited_count > 0
        ? Math.round((agg.citations_count / agg.responses_cited_count) * 100) / 100
        : null;
    return {
      id: String(domainId),
      index: indexOffset + index + 1,
      name: agg.domain,
      logoUrl: getFaviconUrl(agg.domain) || undefined,
      domainType: getDomainType(agg.domain),
      linksCount: agg.links_count,
      usagePercent: totalLinks > 0 ? (agg.links_count / totalLinks) * 100 : 0,
      citations: agg.citations_count,
      averageCitations,
      detailHref: `${ERoutes.Source}${domainId}/`,
    };
  });
}
